import React from 'react';
import clsx from 'clsx';
import CalendarIcon from 'core/icons/calendar';
import {
  getToDoDueDateLabel,
  getToDoDueDateState,
} from 'pages/Dashboard/pages/Todos/date';

type Props = {
  dueDate?: string | Date | null;
  className?: string;
  emptyClassName?: string;
  variant?: 'pill' | 'text';
};

export default function ToDoDueDateValue({
  dueDate,
  className,
  emptyClassName,
  variant = 'pill',
}: Props) {
  if (!dueDate) {
    return <span className={clsx('text-gray-400', emptyClassName)}>--</span>;
  }

  const dueDateState = getToDoDueDateState(dueDate);
  const isTextVariant = variant === 'text';
  const toneClassName = clsx({
    'text-red-500': dueDateState === 'overdue',
    'text-amber-600': dueDateState === 'upcoming',
    'text-primary': dueDateState === 'default',
  });

  return (
    <span
      className={clsx(
        isTextVariant
          ? 'inline-flex items-center gap-1.5 text-xs font-medium leading-5'
          : 'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold leading-5',
        isTextVariant ? toneClassName : {
          'bg-red-50 text-red-600': dueDateState === 'overdue',
          'bg-emerald-50 text-emerald-600': dueDateState === 'upcoming',
          'text-gray-700': dueDateState === 'default',
        },
        className,
      )}
    >
      {isTextVariant && (
        <CalendarIcon className={clsx('!h-4 !w-4', toneClassName)} />
      )}
      {getToDoDueDateLabel(dueDate)}
    </span>
  );
}
